import React from 'react'
import styles from './ColumnResizeHandle.module.scss'

export type ColumnResizeHandleProps = {
  onMouseDown: (event: React.MouseEvent) => void
  onDoubleClick?: () => void
  title?: string
  /** Opt in to a hover colour change — the pivot grid's handle only. `DataTable`'s handle keeps
   * its plain colour on hover. Same optional-boolean-gating-a-CSS-module-class shape as
   * `resizable` on `Modal` in `@ztechapps/webui.modal`. */
  hoverable?: boolean
}

/**
 * The drag handle at the right edge of a resizable column header — shared by `DataTable`
 * (`ActionHeaderCell`) and the pivot grid (`PivotResizeHandle`). The `|` glyph is drawn by CSS
 * (`::before`), so the header carries no text node from it — a literal `|` child breaks an
 * exact-match header-text locator.
 */
export const ColumnResizeHandle = ({ onMouseDown, onDoubleClick, title, hoverable }: ColumnResizeHandleProps) => (
  <div
    className={`${styles.handle} d-inline-block${hoverable ? ` ${styles.hoverable}` : ''} flex-shrink-0`}
    aria-hidden="true"
    title={title}
    onMouseDown={onMouseDown}
    onDoubleClick={onDoubleClick}
    data-testid="column-resize-handle"
  />
)
